//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  setup() {
    const toggleSwiteches = ['primary', 'secondary', 'success', 'info', 'warning', 'error']

    return { toggleSwiteches }
  },
}
